import { Star } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";

export function StarInput({ value, onChange }: { value: number; onChange: (n: number) => void }) {
  const [preview, setPreview] = useState(0);
  const active = preview || value;
  return (
    <div className="flex items-center" onMouseLeave={() => setPreview(0)}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          aria-label={`${n} star${n > 1 ? "s" : ""}`}
          aria-pressed={value === n}
          onMouseEnter={() => setPreview(n)}
          onFocus={() => setPreview(n)}
          onBlur={() => setPreview(0)}
          onClick={() => onChange(n)}
          className="grid size-11 place-items-center rounded focus-visible:outline-2 focus-visible:outline-fg-link"
        >
          <Star
            className={cn(
              "size-6 transition-colors",
              n <= active ? "fill-[#E8A93C] text-[#E8A93C]" : "fill-none text-border-2",
            )}
          />
        </button>
      ))}
    </div>
  );
}
